//typed text
const typed = new Typed(".text", {
    strings: [
        "Peace and joy to you and yours this Christmas season.",
        "Thinking warmly of each of you and wishing your family an extra measure of comfort, joy and hope this Christmas.",
        "I hope your holiday season is full of good things.",
        "Praying you have a wonderful Christmas filled with moments you\u2019ll always remember.",
        "Merry Christmas with lots of love."
    ],
    typeSpeed: 35,
    backSpeed: 25,
    backDelay: 3000,
    loop: true
});
const typed2 = new Typed(".text2", {
    strings: [
        "Merry Christmas...",
        "and Happy New Year!"
    ],
    typeSpeed: 50,
    backSpeed: 50,
    backDelay: 4000,
    loop: true
});
//snowfall
let snowfall = new Snowfall({
    count: 150,
    minRadius: 1,
    maxRadius: 15,
    minSpeed: 1,
    maxSpeed: 7,
    text: "\u2744",
    color: "#ffffff",
    zIndex: "-1"
});
// Update the footer with the current year
const footerYear = new Date().getFullYear();
document.getElementById('footer').innerHTML = `Copyright &copy ${footerYear} by ZsMWebDev | Zsolt M\xe1rku`;

//# sourceMappingURL=merrychristmas.fe997e0e.js.map
